import { render, staticRenderFns } from "./InvoicesDetailsView.vue?vue&type=template&id=6c3acd92&"
import script from "./InvoicesDetailsView.vue?vue&type=script&lang=js&"
export * from "./InvoicesDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDetailsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3acd92')) {
      api.createRecord('6c3acd92', component.options)
    } else {
      api.reload('6c3acd92', component.options)
    }
    module.hot.accept("./InvoicesDetailsView.vue?vue&type=template&id=6c3acd92&", function () {
      api.rerender('6c3acd92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoices/InvoicesDetailsView.vue"
export default component.exports